<template>
  <div class="carregamento" :class="{ 'carregamento--input': tipoCarregamento === 'input' }">
    <v-progress-circular color="rgba(114, 47, 162, 1)" :size="size" :width="width" indeterminate></v-progress-circular>
    <div v-if="mensagemCarregamento">
      {{ mensagemCarregamento }}
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  mensagemCarregamento: {
    type: String,
    default: "Carregando",
  },
  tipoCarregamento: {
    type: String,
    default: "componente",
  },
});

const tipoCarregamento = computed(() => props.tipoCarregamento);

const mensagemCarregamento = computed(() => props.mensagemCarregamento);

const size = computed(() => (props.tipoCarregamento === "input" ? 20 : 40));
const width = computed(() => (props.tipoCarregamento === "input" ? 2 : 4));
</script>

<style scoped>
.carregamento {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100px;
  gap: 8px;
}

.carregamento--input {
  flex-direction: row;
  min-height: auto;
  gap: 6px;
}

.carregamento>div {
  color: var(--roxo-primario);
  text-transform: uppercase;
  font-size: 13px;
}

.carregamento--input>div {
  color: var(--branco);
}
</style>
